<template>
  <div class="page">
    <div class="plate-one">
      <div class="plate-one-logo">
        <img src="@/assets/logo.png" alt="">
      </div>
    </div>
    <div class="plate-two">
      <div class="plate-two-title">
        <img :src="type==3?title1:title2" alt="">
      </div>
    </div>
    <div class="plate-three">
      <div class="plate-three-video">
        <player-video ref="video"></player-video>
      </div>
    </div>
    <div class="plate-four">
      <div class="plate-four-item" v-for="(item, key) in (type==3?liveList[0]:liveList[1])" :key="key" @click="handlePlay(item)">
        <div class="plate-four-item-info">
          <div class="plate-four-item-info-left">
            <img :src="item.poster" alt="">
          </div>
          <div class="plate-four-item-info-right">
            <div class="plate-four-item-info-right-title">{{item.text}}</div>
            <div class="plate-four-item-info-right-desc">{{item.unit}}</div>
          </div>
        </div>
        <img src="@/assets/line.png" class="hidden" alt="">
      </div>
    </div>
    <div class="plate-five">
      <router-link to="/" replace>
        <img src="@/assets/go-home.png" alt="">
      </router-link>
    </div>
  </div>
</template>

<script>
import PlayerVideo from '@/components/video/index'
export default {
  components: { PlayerVideo },
  data() {
    return {
      type: null,
      title1: require('@/assets/title3.png'),
      title2: require('@/assets/title2.png'),
      k: {
        src: '',
        poster: '',
        text: '',
        unit: ''
      },
      liveList: [[
        {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/56e5e9d9/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_072f9fac8dd34b3d8d812cb87bae7237.jpg',
          unit: '徐汇区青少年活动中心',
          text: '微课堂-微生物的“食物”'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/3e83f5a3/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_85bea0519e164f118e468d49ca033225.jpg',
          unit: '徐汇区青少年活动中心',
          text: '微课堂-造纸DIY'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/68e477f1/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_f55802ee6a9f40868ec8d9895fafa15d.jpg',
          unit: '徐汇区青少年活动中心',
          text: '微课堂-“双龙探极”'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/99cf48b6/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_b5d3000bdcfa4aad86599295717fb25f.jpg',
          unit: '上海中学观鸟社',
          text: '我们身边的鸟儿'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/967c0fcd/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_ae82a727523a40d9895ba4582a4c39bb.jpg',
          unit: '徐汇区青少年活动中心',
          text: '上海市青少年“超级景观秀”徐汇区作品'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/6349c833/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_4ed7a328aec44f138ac3e67d66853506.jpg',
          unit: '徐汇区食品药品安全委员会办公室',
          text: '抵制舌尖上的浪费'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/12/6e91d376/m3u8.m3u8',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_56a0e235fd9a490c86856926a64617a3.png',
          unit: '上海科技教育出版社',
          text: '制作蝴蝶贴翅标本书签'
        }, {
          src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/16/f3d5fe44/m3u8.m3u8',
          href: 'https://afr.h5.xeknow.com/s/3npsAy',
          poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_d8f9d02f8f9541df84359dc533d80e8c.png',
          unit: '上海科技教育出版社',
          text: '裸眼3D投影制作'
        }
      ], [{
        src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/0b4c4f94/m3u8.m3u8',
        poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_2b87bbf799aa495f830b736244c1c3fc.png',
        text: '科学家用便便作画',
        unit: '中科院上海巴斯德研究所'
      }, {
        src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/e52cdfed/m3u8.m3u8',
        poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_9c4fb72b43054a5286dd6eaab979c954.jpg',
        text: '不倒翁防跌倒健身操',
        unit: '复旦大学附属中山医院'
      }, {
        src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/08/f266fec7/m3u8.m3u8',
        poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_b9306631c84749f58920904ff51efcb3.jpg',
        text: '老龄化社会的特殊骨折',
        unit: '复旦大学附属中山医院'
      }, {
        src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/7f0c8115/m3u8.m3u8',
        poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_9a6d988b6f3c4ff3837946932c3d262d.jpg',
        text: '打工人的“生物钟”',
        unit: '枫林街道社区卫生服务中心'
      }, {
        src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/08/fa87c130/m3u8.m3u8',
        poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_e6685628c791430e8975f48f75db39df.png',
        text: '益生菌，益生君',
        unit: '复旦大学公共卫生学院'
      }, {
        src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/9e0eb7af/m3u8.m3u8',
        poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_8ffdb80791144c608a5a83c7e9f85a7e.png',
        text: '如何帮助老人床椅转运',
        unit: '中山医院老年护理团队'
      }, {
        src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/ac64c198/m3u8.m3u8',
        poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_a759b5b9d91849498dc14a7cecdf62a1.jpg',
        text: '《打怪历险记》',
        unit: '复旦大学附属徐汇医院儿科'
      }, {
        src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/60262997/m3u8.m3u8',
        poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_543eddc7131b41f381fb21ab01f712f5.jpg',
        text: '肝炎怎么预防？',
        unit: '上海教育出版社、复旦大学附属华山医院感染科'
      }, {
        src: 'http://dongli-yun.oss-cn-shanghai.aliyuncs.com/data/indeximg/IAEA/55/66/88/89/45/2022/09/06/f96e94cc/m3u8.m3u8',
        poster: 'https://imgsauoscom.oss-cn-shanghai.aliyuncs.com/yilininfo/yilininfo_0dc1719373e9457787f70908f8f7b782.jpg',
        text: '手足口病高发防控指南',
        unit: '中科院上海巴斯德研究所'
      }
      ]]
    }
  },
  mounted() {
    this.type = Number(this.$route.query.type)
    setTimeout(() => {
      if (this.type === 3) {
        this.handlePlay(this.liveList[0][0])
      } else {
        this.handlePlay(this.liveList[1][0])
      }
    }, 300)
  },
  methods: {
    handlePlay(item) {
      if (item.src) {
        this.$refs.video.play(item.src)
      } else {
        console.log(999)
        window.location.href = item.href
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  $all-width: 94%;
  .page {
    width: 100%;
    height: 100%;
    background: url(~@/assets/bg3.jpg) no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    img {
      width: 100%;
    }
  }
  .plate-three {
    &-video {
      width: 96%;
      height: 2.01rem;
      margin: auto;
      border: 1px solid #fff;
    }
  }
  .plate-four {
    flex-shrink: 1;
    flex-grow: 1;
    width: 85%;
    margin: auto;
    margin-top: .2rem;
    overflow-y: scroll;
    display: flex;
    flex-direction: column;
    &-item {
      margin-bottom: .15rem;
      &-info {
        display: flex;
        justify-content: space-between;
        color: #fff;
        margin-bottom: .1rem;
        &-left {
          width: 40%;
          height: .718rem;
          img {
            height: 100%;
          }
        }
        &-right {
          width: 58%;
          &-title {
            font-size: .16rem;
            font-weight: 700;
            display: -webkit-box;
            overflow: hidden;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
          }
          &-desc {
            font-size: .14rem;
            // white-space: nowrap;
            // overflow: hidden;
            // text-overflow: ellipsis;
          }
        }
      }
    }
    &-item:nth-last-of-type(1) {
      margin-bottom: 0;
      .plate-four-item-info {
        margin-bottom: 0;
      }
      .hidden {
        display: none;
      }
    }
  }
  .plate-five {
    width: 25%;
    padding: .2rem 0;
    margin: 0 auto;
    animation-name: btn;
    animation-duration: 1.5s;
    animation-direction: alternate;
    animation-iteration-count: infinite;
  }
  @keyframes btn {
    0% {
      opacity: 1;
      transform: scale(1);
    }
    100% {
      opacity: .4;
      transform: scale(.9);
    }
  }
</style>
